/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { LevelStats } from './levelStats';
import { SkillNode } from './skillNode';

export interface SubareaNode { 
    id: string;
    name: string;
    shortName: string;
    description: string;
    color: string;
    watchedCount: number;
    areaName: string;
    areaId: string;
    firstLevelDone: boolean;
    secondLevelDone: boolean;
    thirdLevelDone: boolean;
    firstLevelDoneCount: number;
    secondLevelDoneCount: number;
    thirdLevelDoneCount: number;
    level1Stats: LevelStats;
    level2Stats: LevelStats;
    level3Stats: LevelStats;
    touchCount: number;
    children: Array<SkillNode>;
}